// src/routesConfig.js
import { LuLayoutDashboard, LuMapPinned } from "react-icons/lu";
import { LiaHorseHeadSolid } from "react-icons/lia";  // ← CHANGÉ ICI
import { MdImageSearch, MdOutlinePeopleAlt } from "react-icons/md";
import { PiSyringeBold } from "react-icons/pi";
import { FaListUl } from "react-icons/fa6";
import { TbSettings } from "react-icons/tb";
import { MoreHorizontal } from "lucide-react";
import { PiHouseLineBold } from "react-icons/pi";


export const ROUTES = [
  {
    path: "/tableau-bord",
    label: "Pilotage",
    icon: LuLayoutDashboard,
    primaryMobile: true,
  },
  {
    path: "/carte",
    label: "Carte",
    icon: LuMapPinned,
    primaryMobile: true,
  },
  {
    path: "/animaux",
    label: "Animaux",
    icon: LiaHorseHeadSolid,  // ← CHANGÉ ICI
    primaryMobile: true,
  },
  {
    path: "/zones",
    label: "Zones",
    icon: PiHouseLineBold,
    primaryMobile: true,
  },
  {
    path: "/actes",
    label: "Actes",
    icon: PiSyringeBold,
    primaryMobile: true,
  },
  // secondaires (affichées dans "Plus" sur mobile)
  {
    path: "/proprietaires",
    label: "Propriétaires",
    icon: MdOutlinePeopleAlt,
  },
  {
    path: "/liste-chevaux",
    label: "Liste des chevaux",
    icon: FaListUl,
  },
  {
    path: "/parametres",
    label: "Paramètres",
    icon: TbSettings,
  },
];

export const MORE_ICON = MoreHorizontal;